var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heuristic"},[(
    _vm.$store.state.auth.user.perm !== 'admin'
    || typeof _vm.$route.query.edit === 'undefined'
  )?_c('view-heu'):_c('edit-heu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }